import { AppTopBar } from '../components/AppTopBar.js';
import { Breadcrumbs } from '../components/Breadcrumbs.js';
import { CustomDbsPanel } from '../components/CustomDbsPanel.js';

export function CustomDbsPage() {
  return (
    <>
      <AppTopBar />
      <Breadcrumbs items={[{ label: 'Inicio', to: '/projects' }, { label: 'Mis BDs' }]} />
      <CustomDbsPanel />
    </>
  );
}
